export { default } from './banner-editorial'
